module.exports = __webpack_public_path__ + "static/img/mode-active@2x.7b588dd1.png";